import { ExchangeMissingTradeHistoryPermissionError, InvalidCredentialsError } from "@cede/utils";
import { create } from "zustand";

export interface ExchangeAccountFormData {
  authMethod: string;
  selectedCex: string;
  apiKey: string;
  secretKey: string;
  uid: string | undefined; // optional on some exchanges so we don't send it with empty values
  password: string | undefined; // optional on some exchanges so we don't send it with empty values
}

interface CreateAccountStore {
  formData: ExchangeAccountFormData;
  updateFormData: (data: Partial<ExchangeAccountFormData>) => void;
  reset: () => void;
  error: null | InvalidCredentialsError | ExchangeMissingTradeHistoryPermissionError;
  setError: (error: InvalidCredentialsError | ExchangeMissingTradeHistoryPermissionError | null) => void;
}

export const useCreateAccountStore = create<CreateAccountStore>((set) => ({
  formData: {
    authMethod: "",
    selectedCex: "",
    apiKey: "",
    secretKey: "",
    uid: undefined,
    password: undefined,
  },

  updateFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data },
    })),
  reset: () =>
    set({
      error: null,
      formData: {
        authMethod: "",
        selectedCex: "",
        apiKey: "",
        secretKey: "",
        uid: undefined,
        password: undefined,
      },
    }),
  error: null,
  setError: (error) => set({ error }),
}));
